import React, { useEffect, useState } from 'react';
import { loadAgents } from '../services/customers';
import { assignAgent } from '../services/leads';
import '../pages/Routes/StatusUpdateSheet.css';

/**
 * Admin only: who goes to this visit. Opens from "Not assigned" or the agent's name (Route card,
 * appointment page, customer account). Pick → Save → Zoho (refused if that agent is already booked then).
 * lead: { id, contactName, agentName } · onSaved(agentName) for screens that keep their own copy.
 */
const AgentPicker = ({ lead, onClose, onSaved }) => {
  const [agents, setAgents] = useState(null);
  const [pick, setPick] = useState(null);
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    loadAgents()
      .then((list) => {
        setAgents(list);
        setPick(list.find((a) => a.name === lead.agentName) || null);
      })
      .catch((err) => setError(err.message));
  }, [lead.agentName]);

  const unchanged = !pick || pick.name === lead.agentName;

  const save = async () => {
    setSaving(true);
    setError('');
    try {
      await assignAgent(lead.id, pick, { contactName: lead.contactName, agentName: lead.agentName });
      if (onSaved) onSaved(pick.name);
      onClose();
    } catch (err) {
      setError(err.message);
      setSaving(false);
    }
  };

  return (
    <div className="status-sheet-overlay" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="status-sheet" role="dialog" aria-label="Assign agent">
        <div className="status-sheet-grab" />
        <div className="status-sheet-head">
          <div>
            <h3>{lead.agentName ? 'Change agent' : 'Assign an agent'}</h3>
            <p>{lead.contactName}</p>
          </div>
          <button type="button" className="status-sheet-close" onClick={onClose} aria-label="Close">✕</button>
        </div>

        <div className="status-sheet-body">
          {!agents && !error && <p className="status-help">Loading agents…</p>}
          {agents && !agents.length && <p className="status-help">No active agents in Zoho.</p>}
          {agents && (
            <div className="status-options">
              {agents.map((a) => (
                <button
                  key={a.id}
                  type="button"
                  className={`status-option${pick && pick.id === a.id ? ' selected' : ''}`}
                  onClick={() => {
                    setPick(a);
                    setError('');
                  }}
                >
                  <span className="status-option-icon">👤</span>
                  <span className="status-option-text">
                    <b>{a.name}</b>
                    {a.name === lead.agentName && <small>Assigned now</small>}
                  </span>
                  <span className="status-option-radio" />
                </button>
              ))}
            </div>
          )}
          {error && <p className="status-error">{error}</p>}
        </div>

        <div className="status-sheet-foot">
          <button type="button" className="status-cancel" onClick={onClose}>Cancel</button>
          <button type="button" className="status-save" disabled={unchanged || saving} onClick={save}>
            {saving ? 'Saving…' : 'Save'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AgentPicker;
